import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@mantine/core';

import { useAddProphetPage } from '../../api/addPage';

import { PageForm } from './PageForm';

import { Departments, Platforms } from '@/types';

type Props = {
  platform: Platforms;
  department: Departments;
};

export const AddModal = NiceModal.create(({ platform, department }: Props) => {
  const modal = useModal();

  const { mutate, isLoading } = useAddProphetPage({ onSuccess: modal.hide });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="New page"
    >
      <PageForm
        mode="create"
        onSubmit={(data) =>
          // Explicit fields instead of a spread: FormValues carries the limit
          // fields, which PUT /prophet/pages does not accept (edit-only).
          mutate({
            appPage: data.appPage,
            funnels: data.funnels,
            aiId: data.aiId,
            platform,
            department,
          })
        }
        isLoading={isLoading}
        platform={platform}
        department={department}
      />
    </Modal>
  );
});
